import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from './store';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import PortCoUserPage from 'pages/portcoUserData';
import { AuthProvider } from './context/AuthContext';
import AuthPortCoGuard from 'components/AuthPortCoGuard';
import StatsigWrapper from 'components/StatsigWrapper';
import '@fontsource/open-sans/400.css';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || ''
};
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root') as Element);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <StatsigWrapper>
            <Routes>
              <Route path='/' element={<App />} />
              <Route
                path='/company-data'
                element={
                  <AuthPortCoGuard>
                    <PortCoUserPage />
                  </AuthPortCoGuard>
                }
              />
              <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
          </StatsigWrapper>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
